/* eslint-disable prettier/prettier */
export default {
  dbh_feedback: 'Feedback',
  dbh_feedback_success_tips: 'Feedback success!',
  dbh_feedback_error_tips: 'Feedback Error!',
  dbh_feedback_tips:
    `Shower us with praise, or flame us for a bug. We'd love to get your feedback`,
  dbh_feedback_textarea_placeholder: 'Leave your feedback',
  dbh_feedback_upload_img_control_label: 'Upload images',
  dbh_feedback_upload_img_control_text: 'Select image',
  dbh_feedback_upload_img_control_tips: 'Support batch upload',
  dbh_feedback_uploading_text: 'Uploading...',
  dbh_feedback_upload_img_incorrect_format_tips: 'Incorrect file format',
  dbh_feedback_upload_img_error_msg: 'Upload failed, please upload again',
  dbh_feedback_use_feedback_template: 'Use feedback template',
};
